
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-81aaf250&scoped=true!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PrimaryProductDetailComponent.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrimaryProductDetailComponent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-81aaf250!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrimaryProductDetailComponent.vue"),
  /* scopeId */
  "data-v-81aaf250",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/grid/PrimaryProductDetailComponent.vue
// module id = 230
// module chunks = 2